import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { ReactNode } from 'react'

type Props = {
  isFull?: boolean
  children: ReactNode
  title: string
}

const Report = ({ children, isFull, title }: Props) => {
  return (
    <Grid item xs={12} md={isFull ? 12 : 6}>
      <Paper elevation={1}>
        <Box height={400} p={2} position={'relative'}>
          <Typography variant="h6">{title}</Typography>
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            {children}
          </Box>
        </Box>
      </Paper>
    </Grid>
  )
}

export default Report
